import gs from '@kk/gs';

export function getGS(activityId) {
    const url = `${location.protocol}//${location.host}/v1/aegis/api/web/challenge?callback=activity${activityId}`;
    return gs(url);
}
